<script>
  import { POPUP_COOKIE_NAME } from "$lib/utilities/constants";
  import { getCookie, setCookie } from "$lib/utilities/cookies";
  import { PopUp } from "@ObamaFoundation/of-design-system";
  import { onMount } from "svelte";
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";
  import { seoCanonicalLinkStore } from "$lib/stores";
  import { textToId } from "$lib/utilities/dom-helpers";

  export let data;

  const { theme, headline, subtext, ctaText, ctaUrl, image, pagesToHide, pagesToShow } =
    data.fields;

  let id = `popup-${textToId(headline)}`;

  const cta = {
    text: ctaText,
    url: ctaUrl
  };

  const imageProps = {
    src: image ? `https:${image?.fields.imageAsset.fields.file.url}` : undefined,
    alt: image ? image?.fields.altText : undefined
  };

  let shouldHide = true;

  const calculateHiddenState = () => {
    const path = $page.url.pathname;
    const formParam = $page.url.searchParams.get("form");

    shouldHide =
      !window.OneTrust?.IsAlertBoxClosed() ||
      getCookie(POPUP_COOKIE_NAME) === "dismissed" ||
      pagesToHide?.includes(path) ||
      (pagesToShow && !pagesToShow?.includes(path)) ||
      $seoCanonicalLinkStore === "/donate/" ||
      formParam ||
      ctaUrl === path;

    if (!shouldHide) {
      fireTrackingEvent({
        event: "pop-up-viewed",
        "pop-up_id": id,
        "pop-up_type": `standard_${image ? "with_image" : "without_image"}`,
        page_url: $page.url,
        trigger_type: "on_page_load"
      });
    }
  };

  const fireTrackingEvent = (eventData) => {
    window.dataLayer.push(eventData);
  };

  const handleDismissal = (event) => {
    setCookie(POPUP_COOKIE_NAME, "dismissed", 1);
    fireTrackingEvent({
      event: `${event.detail.method.endsWith("_cta") ? "pop-up_cta_clicked" : "pop-up_closed"}`,
      "pop-up_id": id,
      method: event.detail.method
    });
  };

  onMount(() => {
    calculateHiddenState();

    window.addEventListener("OneTrustGroupsUpdated", () => {
      setTimeout(() => {
        calculateHiddenState();
      }, 800);
    });
  });
</script>

<PopUp
  {id}
  on:dismissal={handleDismissal}
  hidden={shouldHide}
  {theme}
  {headline}
  {subtext}
  {cta}
  image={imageProps.src ? imageProps : undefined}
/>
